import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { first } from 'rxjs/operators';
import { InDetailsBuyOrderModalComponent } from '../../modals/in-details-buy-order-modal/in-details-buy-order-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NfeInModalComponent } from 'src/app/modals/nfe-in-modal/nfe-in-modal.component';
import { UserRoles } from 'src/models/User';
import {
  InOrdersFilterParams,
  InOrdersService,
  InOrdersSortParams
} from 'src/app/core/services/in-orders.service';
import { InOrder, InOrderState } from 'src/models/InOrder';
import * as moment from 'moment';

@Component({
  selector: 'app-in',
  templateUrl: './in.component.html',
  styleUrls: ['./in.component.scss']
})
export class InComponent implements OnInit {
  userRole: UserRoles = null;
  actualHour;
  orderModalsOpened = new Set();
  isLoading: boolean;
  isModalLoading = false;
  ordersMap: Map<string, InOrder> = new Map();
  receivingOrders: InOrder[] = [];
  createdOrders: InOrder[] = [];
  createdFilters: InOrdersFilterParams = {};
  receivingFilters: InOrdersFilterParams = {};
  createdSortParams: InOrdersSortParams;
  receivingSortParams: InOrdersSortParams;

  constructor(
    public dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private inOrdersService: InOrdersService
  ) { }

  ngOnInit(): void {
    this.userRole = this.route.snapshot.data.role;
    this.update();
  }

  openOrderDetailsModal(order: InOrder) {
    this.dialog.open(InDetailsBuyOrderModalComponent, {
      panelClass: 'details-modal',
      autoFocus: false,
      data: order
    });
  }

  async toHomePage() {
    await this.router.navigate(['/dashboard']);
  }

  async toInspection() {
    await this.router.navigate(['/inspection']);
  }

  onFiltersApply(
    table: 'created' | 'receiving',
    params: { filterParams: InOrdersFilterParams, sortParams: InOrdersSortParams }
  ) {
    if (table === 'created') {
      this.createdFilters = params?.filterParams || {};
      this.createdSortParams = params?.sortParams;
    } else {
      this.receivingFilters = params?.filterParams || {};
      this.receivingSortParams = params?.sortParams;
    }
    this.update();
  }

  async update() {
    this.isLoading = true;
    const [createdResponse, receivingResponse] = await Promise.all([
      this.inOrdersService.getAll(this.createdFilters, this.createdSortParams),
      this.inOrdersService.getAll(this.receivingFilters, this.receivingSortParams)
    ]);
    this.createdOrders = createdResponse.values.filter(order => order.state === InOrderState.CREATED);
    this.receivingOrders = receivingResponse.values.filter(order => order.state === InOrderState.RECEIVING);
    this.ordersMap.clear();
    [...this.createdOrders, ...this.receivingOrders].forEach(order => this.ordersMap.set(order.id, order));
    this.actualHour = moment().format('HH:mm');
    this.isLoading = false;
  }

  openNfeInModal() {
    const dialogRef = this.dialog.open(NfeInModalComponent, {
      panelClass: 'manual-picking-modal',
      data: { userRole: this.userRole },
      autoFocus: false
    });
    dialogRef.afterClosed().pipe(first()).subscribe(res => {
      if (res === 'SUBMITTED') {
        this.update();
      }
    });
  }
}
